module.exports = __webpack_public_path__ + "static/logo-80e94fccefce1cf965cbed486491b0f4.svg";